module.exports = __webpack_public_path__ + "static/media/Mediaset.c8968ce5.png";